"use client";

import { c as _c } from "react/compiler-runtime";
import type { SanityReference } from "next-sanity";
import type { CSSProperties } from "react";
import TrackingPixel from "src/components/ads/TrackingPixel";
import CmsImageForAssetRef from "src/components/images/CmsImageForAssetRef";
import { getOrgSize } from "src/components/images/imageFunctions";
import StreamingguideLogo from "src/components/streaming/StreamingguideLogo";
import FilmwebLogoSvg from "src/components/svg/FilmwebLogoSvg";
import useSsrSafeMediaQuery from "src/lib/client/useSsrSafeMediaQuery";
import styles from "./TopOfPageSponsor.module.css";
import classNames from "classnames";

//#region [Props]
type TopOfPageSponsorProps = {
  mobileImages?: SanityReference[] | null;
  desktopImages?: SanityReference[] | null;
  clickUrl?: string | null;
  sponsorText?: "none" | "streaming" | "filmweb";
  hideSponsorTextMobile?: boolean;
  className?: string;
};
//#endregion

//#region [Component]
export default function TopOfPageSponsor(t0) {
  const $ = _c(39);
  const {
    className,
    mobileImages,
    desktopImages,
    clickUrl,
    sponsorText: t1,
    hideSponsorTextMobile: t2
  } = t0;
  const sponsorText = t1 === undefined ? "none" : t1;
  const hideSponsorTextMobile = t2 === undefined ? false : t2;
  const isDesktop = useSsrSafeMediaQuery("(min-width: 550px)");
  if (!mobileImages && !desktopImages) {
    return null;
  }
  let t3;
  if ($[0] !== desktopImages) {
    t3 = desktopImages?.map(_temp);
    $[0] = desktopImages;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const desktopSizes = t3;
  let t4;
  if ($[2] !== mobileImages) {
    t4 = mobileImages?.map(_temp2);
    $[2] = mobileImages;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const mobileSizes = t4;
  const t5 = sponsorText !== "none" ? "50%" : "100%";
  let ccstyles;
  if ($[4] !== desktopSizes || $[5] !== mobileSizes || $[6] !== t5) {
    ccstyles = {
      "--sponsor-flex": t5
    };
    if (!!desktopSizes && desktopSizes.length > 0) {
      ccstyles["--sponsor-height-d"] = `${desktopSizes[0].height}px`;
      ccstyles["--sponsor-flex"] = `${desktopSizes[0].width}px`;
    }
    if (!!mobileSizes && mobileSizes.length > 0) {
      ccstyles["--sponsor-height-m"] = `${mobileSizes[0].height}px`;
    }
    $[4] = desktopSizes;
    $[5] = mobileSizes;
    $[6] = t5;
    $[7] = ccstyles;
  } else {
    ccstyles = $[7];
  }
  const hasDesktopImages = (desktopImages?.length ?? 0) > 0;
  const hasMobileImages = (mobileImages?.length ?? 0) > 0;
  let t6;
  if ($[8] !== className || $[9] !== hasDesktopImages || $[10] !== hasMobileImages) {
    t6 = classNames(styles.STopOfPageSponsorOuterContainer, className, {
      [styles.hasMobile]: hasMobileImages,
      [styles.hasDesktop]: hasDesktopImages
    });
    $[8] = className;
    $[9] = hasDesktopImages;
    $[10] = hasMobileImages;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = ccstyles as CSSProperties;
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = classNames("topOfPageSponsorInnerContainer", styles.STopOfPageSponsorContainer);
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== hideSponsorTextMobile || $[14] !== sponsorText) {
    t9 = sponsorText === "streaming" && <div className={classNames(styles.SSGLogo, {
      [styles.hideSponsorTextMobile]: hideSponsorTextMobile
    })}><StreamingguideLogo className={styles.SStreamingguideLogo} /><div className={styles.SCooperation}>i samarbeid med</div></div>;
    $[13] = hideSponsorTextMobile;
    $[14] = sponsorText;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== hideSponsorTextMobile || $[17] !== sponsorText) {
    t10 = sponsorText === "filmweb" && <div className={classNames(styles.SSGLogo, {
      [styles.hideSponsorTextMobile]: hideSponsorTextMobile
    })}><FilmwebLogoSvg className={styles.SFilmwebLogoSvg} /><div className={styles.SCooperation}>i samarbeid med</div></div>;
    $[16] = hideSponsorTextMobile;
    $[17] = sponsorText;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== clickUrl || $[20] !== desktopImages || $[21] !== hasDesktopImages || $[22] !== hasMobileImages || $[23] !== mobileImages || $[24] !== sponsorText) {
    t11 = !!clickUrl ? <a href={clickUrl} target="_blank" className={classNames(styles.SSponsorLink, sponsorText !== "none" ? styles.streamingguideSponsor : styles.sponsor)}>{hasMobileImages && <CmsImageForAssetRef className={styles.SMobileCmsImageForAssetRef} assetRef={mobileImages[0]._ref} alt="Sponsorat" />}{hasDesktopImages && <CmsImageForAssetRef className={styles.SDesktopCmsImageForAssetRef} assetRef={desktopImages[0]._ref} alt="Sponsorat" unoptimized={true} />}</a> : <div className={classNames(styles.SSponsorLink, sponsorText !== "none" ? styles.streamingguideSponsor : styles.sponsor)}>{hasMobileImages && <CmsImageForAssetRef className={styles.SMobileCmsImageForAssetRef} assetRef={mobileImages[0]._ref} alt="Sponsorat" />}{hasDesktopImages && <CmsImageForAssetRef className={styles.SDesktopCmsImageForAssetRef} assetRef={desktopImages[0]._ref} alt="Sponsorat" unoptimized={true} />}</div>;
    $[19] = clickUrl;
    $[20] = desktopImages;
    $[21] = hasDesktopImages;
    $[22] = hasMobileImages;
    $[23] = mobileImages;
    $[24] = sponsorText;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t7 || $[29] !== t9) {
    t12 = <div style={t7} className={t8}>{t9}{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t7;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== hasDesktopImages || $[32] !== hasMobileImages || $[33] !== isDesktop) {
    t13 = (isDesktop && hasDesktopImages || !isDesktop && hasMobileImages) && <TrackingPixel className={styles.STrackingPixel} targetId="SponsorTrackingPixel" />;
    $[31] = hasDesktopImages;
    $[32] = hasMobileImages;
    $[33] = isDesktop;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t12 || $[36] !== t13 || $[37] !== t6) {
    t14 = <div className={t6}>{t12}{t13}</div>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t6;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}
//#endregion

//#region [Styles]
// Moved to TopOfPageSponsor.module.css
//#endregion
function _temp2(img_0) {
  return getOrgSize(img_0._ref);
}
function _temp(img) {
  return getOrgSize(img._ref);
}